var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"verified":_vm.verified,"check":_vm.checkTickets,"reset":_vm.checkVerification,"phone":_vm.phone,"save":_vm.save})],2)}
var staticRenderFns = []

export { render, staticRenderFns }